import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import StyledSystemPropTypes from '@styled-system/prop-types';

import { Box, Flex } from '../../grid';
import { P } from '../../typography';
import { TableTemplate } from '..';

const SpacedTable = ({ headers, data, detailWidth }) => (
  <TableTemplate headers={headers}>
    {data.map(({ key, value, boldKey, boldValue }) => (
      <tr data-testid="spaced-table-id" key={key}>
        <td>
          <Flex alignItems="center" justifyContent="space-between" width="100%">
            <Box width={detailWidth}>
              <Details bold={boldKey}>{key}</Details>
            </Box>
            <Box width={detailWidth}>
              <Details bold={boldValue}>{value}</Details>
            </Box>
          </Flex>
        </td>
      </tr>
    ))}
  </TableTemplate>
);

const Details = styled(P)`
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
`;

SpacedTable.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
      boldKey: PropTypes.bool,
      boldValue: PropTypes.bool,
    })
  ).isRequired,
  detailWidth: StyledSystemPropTypes.layout.width,
};

SpacedTable.defaultProps = {
  detailWidth: 'auto',
};

export { SpacedTable };
